import { combine } from 'effector'
import { model as eventsDetailsModel } from '~/routes/events/details'
import { model as moviesDetailsModel } from '~/routes/movies/details'
import { model as showsDetailsModel } from '~/routes/shows/details'

export const $isContentDetailsLoading = combine(
  moviesDetailsModel.$isDetailsPageLoading,
  showsDetailsModel.$isDetailsPageLoading,
  eventsDetailsModel.$isDetailsPageLoading,
  (movies, shows, events) => movies || shows || events
)
